import store from "@/store";

export default function isSmsVerified({ next, router }) {
  const isVerifiedSMS = store.getters["user/getCurrentUserVerified"];
  let currentUserRole = store.getters["user/getCurrentUserRole"];

  if (isVerifiedSMS || currentUserRole === "admin") {
    return next();
  }

  return router.push({ name: "DoctorVerifyPhoneNumber" });
}
